<template>
  <el-dialog :title="$t('activitiesManage.edit.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('activitiesManage.edit.title')" prop="title">
        <el-input v-model="form.title" :placeholder="$t('activitiesManage.edit.titlePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.edit.typeCd')" prop="typeCd">
        <el-select v-model="form.typeCd" :placeholder="$t('activitiesManage.edit.typeCdPlaceholder')" style="width:100%">
          <el-option v-for="item in typeCds" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.edit.headerImg')" prop="headerImg">
        <upload-image-url ref="uploadImage" :limit="1" @notifyUploadCoverImage="handleImageChange" />
      </el-form-item>
      <el-form-item label="跳转方式" prop="linkType">
        <el-select v-model="form.linkType" placeholder="请选择跳转方式" style="width:100%">
          <el-option label="系统活动（详情页）" value="0" />
          <el-option label="外部链接（公众号/H5）" value="1" />
          <el-option label="其他小程序" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.linkType === '1'" label="外部链接" prop="linkUrl">
        <el-input v-model="form.linkUrl" placeholder="请输入完整链接，如 https://..." />
      </el-form-item>
      <el-form-item v-if="form.linkType === '2'" label="小程序appId" prop="miniAppId">
        <el-input v-model="form.miniAppId" placeholder="目标小程序的 appId" />
      </el-form-item>
      <el-form-item v-if="form.linkType === '2'" label="小程序页面">
        <el-input v-model="form.miniPath" placeholder="目标页面路径，可空，如 pages/index/index" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.edit.startTime')" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"          :placeholder="$t('activitiesManage.edit.startTimePlaceholder')" style="width:100%"
           />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.edit.endTime')" prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"          :placeholder="$t('activitiesManage.edit.endTimePlaceholder')" style="width:100%"
           />
      </el-form-item>
      <el-form-item v-if="form.linkType === '0'" :label="$t('activitiesManage.edit.context')" prop="context">
        <rich-text-editor ref="richTextEditor" v-model="form.context" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { updateActivities, getActivitiesDetail, listActivitiesType } from '@/api/oa/activitiesManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from "@/components/editor/RichTextEditor";

export default {
  name: 'EditActivitiesView',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        activitiesId: '',
        title: '',
        typeCd: '',
        headerImg: '',
        context: '',
        startTime: '',
        endTime: '',
        communityId: '',
        linkType: '0',
        linkUrl: '',
        miniAppId: '',
        miniPath: ''
      },
      typeCds: [],
      rules: {
        title: [
          { required: true, message: this.$t('activitiesManage.validate.titleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('activitiesManage.validate.titleMaxLength'), trigger: 'blur' }
        ],
        typeCd: [
          { required: true, message: this.$t('activitiesManage.validate.typeCdRequired'), trigger: 'change' }
        ],
        headerImg: [
          { required: true, message: this.$t('activitiesManage.validate.headerImgRequired'), trigger: 'change' }
        ],
        linkUrl: [
          {
            validator: (rule, value, callback) => {
              if (this.form.linkType === '1' && (!value || value === '')) {
                callback(new Error('请输入外部链接地址'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        miniAppId: [
          {
            validator: (rule, value, callback) => {
              if (this.form.linkType === '2' && (!value || value === '')) {
                callback(new Error('请输入目标小程序appId'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        context: [
          {
            validator: (rule, value, callback) => {
              if (this.form.linkType === '0' && (!value || value === '')) {
                callback(new Error(this.$t('activitiesManage.validate.contextRequired')))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        startTime: [
          { required: true, message: this.$t('activitiesManage.validate.startTimeRequired'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('activitiesManage.validate.endTimeRequired'), trigger: 'change' }
        ],
        activitiesId: [
          { required: true, message: this.$t('activitiesManage.validate.activitiesIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(async () => {
        this.$refs.form && this.$refs.form.resetFields()
        this.loadActivitiesType()
        await this.loadActivitiesDetail(row.activitiesId)
      })
    },
    async loadActivitiesType() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: getCommunityId()
        }
        const { data } = await listActivitiesType(params)
        this.typeCds = data
      } catch (error) {
        console.error('获取活动类型失败:', error)
      }
    },
    async loadActivitiesDetail(activitiesId) {
      try {
        const params = {
          activitiesId,
          page: 1,
          row: 50,
          communityId: getCommunityId()
        }
        const {activitiess} = await getActivitiesDetail(params)
        this.form = { ...activitiess[0] }
        if (!this.form.linkType) {
          this.form.linkType = '0'
        }
        this.$refs.uploadImage.setImages([activitiess[0].headerImg])
        this.$nextTick(() => {
          if (this.$refs.richTextEditor) {
            this.$refs.richTextEditor.setContent(activitiess[0].context)
          }
        })
      } catch (error) {
        console.error('获取活动详情失败:', error)
      }
    },
    handleImageChange(images) {
      this.form.headerImg = images.length > 0 ? images[0] : ''
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            await updateActivities(this.form)
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('更新活动失败:', error)
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>